/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './diaglab-department-access.reducer';

export const DiaglabDepartmentAccessDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const diaglabDepartmentAccessEntity = useAppSelector(state => state.diaglabDepartmentAccess.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="diaglabDepartmentAccessDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.diaglabDepartmentAccess.detail.title">DiaglabDepartmentAccess</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.diaglabDepartmentAccess.id">Id</Translate>
            </span>
          </dt>
          <dd>{diaglabDepartmentAccessEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.diaglabDepartmentAccess.active">Active</Translate>
            </span>
          </dt>
          <dd>{diaglabDepartmentAccessEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.diaglabDepartmentAccess.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{diaglabDepartmentAccessEntity.lastUpdated}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.diaglabDepartmentAccess.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{diaglabDepartmentAccessEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.diaglabDepartmentAccess.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{diaglabDepartmentAccessEntity.microSec}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.diaglabDepartmentAccess.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{diaglabDepartmentAccessEntity.cursor}</dd>
          <dt>
            <span id="userId">
              <Translate contentKey="tinyMedicRestApp.diaglabDepartmentAccess.userId">User Id</Translate>
            </span>
            <UncontrolledTooltip target="userId">
              <Translate contentKey="tinyMedicRestApp.diaglabDepartmentAccess.help.userId" />
            </UncontrolledTooltip>
          </dt>
          <dd>{diaglabDepartmentAccessEntity.userId}</dd>
          <dt>
            <span id="userRole">
              <Translate contentKey="tinyMedicRestApp.diaglabDepartmentAccess.userRole">User Role</Translate>
            </span>
            <UncontrolledTooltip target="userRole">
              <Translate contentKey="tinyMedicRestApp.diaglabDepartmentAccess.help.userRole" />
            </UncontrolledTooltip>
          </dt>
          <dd>{diaglabDepartmentAccessEntity.userRole}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabDepartmentAccess.diagLab">Diag Lab</Translate>
          </dt>
          <dd>{diaglabDepartmentAccessEntity.diagLab ? diaglabDepartmentAccessEntity.diagLab.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabDepartmentAccess.department">Department</Translate>
          </dt>
          <dd>{diaglabDepartmentAccessEntity.department ? diaglabDepartmentAccessEntity.department.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/diaglab-department-access" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/diaglab-department-access/${diaglabDepartmentAccessEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DiaglabDepartmentAccessDetail;
